import React from 'react';
import { DropdownMenu, Form } from 'reactstrap';
import ColumnSelect from '../../../utility/ColumnSelect';
import DirectionSelect from '../../../utility/DirectionSelect';
import CurrentSortDisplay from '../../../utility/CurrentSortDisplay';

const SortOrderDialog = ({
  sortableColumns,
  newSort,
  setNewSort,
  handleApply
}) => {
  return (
    <DropdownMenu
      style={{
        padding: '1rem',
        minWidth: '260px',
        maxWidth: '300px',
        borderRadius: '0.5rem'
      }}
    >
      <Form>
        <ColumnSelect
          columns={sortableColumns}
          value={newSort.column}
          onChange={col => setNewSort({ ...newSort, column: col })}
        />

        <DirectionSelect
          value={newSort.direction}
          onChange={dir => setNewSort({ ...newSort, direction: dir })}
        />

        <CurrentSortDisplay
          column={newSort.column}
          direction={newSort.direction}
          columns={sortableColumns}
          onApply={handleApply}
        />
      </Form>
    </DropdownMenu>
  );
};

export default SortOrderDialog;
